import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _ from 'lodash';
import FaAdd from 'react-icons/lib/fa/plus';

import './projectsSummaryList.scss';

import projectsStore from 'storeState/projects';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import Button from "views/button/Button";
import Loading from "views/loading/Loading";
import InternalLink from 'components/views/internalLink/InternalLink';

import {formatDateTime} from 'service/LocaleService';

export class ProjectsSummaryList extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    componentDidMount() {

    }

    onProjectClick = (project_id) => {
        if(this.props.onProjectSelect) {
            this.props.onProjectSelect(project_id);
        }
    }

    render() {
        return (
            <Loading finished={!this.props.projectsLoading} render={(()=>
              <div className={`projects-summary-list`}>
                <If condition={this.props.projects}>
                  <For each="item" of={this.props.projects}>
                    <div onClick={() => this.onProjectClick(item.id)} className="projects-summary-list-item clickable">
                      <div className="projects-summary-list-item-name">
                        {item.name}
                      </div>
                      <div className="projects-summary-list-item-date">
                        <FormattedMessage id="projectsList.created_at" defaultMessage="Created at" />&nbsp;
                        {formatDateTime(item.created_at)}
                      </div>
                    </div>
                  </For>
                  <InternalLink to={"projects"} >
                    <div className="projects-summary-list-item new clickable">
                      <div className="projects-summary-list-item-new">
                        <FaAdd /> <FormattedMessage id="projectsList.button.new" defaultMessage="Start a new Project" />
                      </div>
                    </div>
                  </InternalLink>
                </If>
              </div>
            ).bind(this)} />
        );
    }
}


export default connect((state, props) => {
  return {
    projects: projectsStore.selectors.projectsList(state),
    projectsLoading: projectsStore.selectors.projectsLoading(state),
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, projectsStore.actions), dispatch)
  }
})(ProjectsSummaryList)



// WEBPACK FOOTER //
// ./src/components/views/projectsSummaryList/ProjectsSummaryList.js